import { usePeopleAPI } from "@certn/legacy-api";

export function useDeleteReasons() {
  const { data: deleteReasons, isLoading } = usePeopleAPI(
    "/internal/people/delete-reasons/"
  );

  return {
    deleteReasons,
    isLoading,
  };
}
